import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import DabaduTooltip from 'sharedComponents/toolTip';

const DabaduInput = styled(TextField)`
  & .MuiInputBase-root {
    border-radius: 4px;
    font-weight: 300;
    font-size: 1rem;
    letter-spacing: 0;
    line-height: 1.5;
    font-family: ${(props) => props.theme.fonts.primary};
    color: ${(props) => props.theme.colors.textColor};
    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
  }
  & .MuiInputBase-input {
    height: auto;
    padding: 18px 20px;

    @media (max-width: 1650px) {
      padding: 12px 14px;
    }
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.colors.inputBorder};
  }
  & .MuiOutlinedInput-root {
    &:hover,
    &:active {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props: { error?: boolean; warning?: boolean; success?: boolean }) => {
          return props.error
            ? '${(props) => props.theme.colors.dangerColor}'
            : props.success
              ? '#3CC13B'
              : props.warning
                ? '#F3BB1C'
                : '${(props) => props.theme.colors.inputBorder}';
        }};
      }
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
  }
  & .MuiFormHelperText-root {
    &.Mui-error {
      margin-left: 0;
      color: ${(props) => props.theme.colors.dangerColor};
      font-family: ${(props) => props.theme.fonts.primary};
    }
  }
`;

export const CommonInput = ({
  name,
  control,
  label,
  placeholder,
  rules,
  hint,
  type = 'text',
  triggerValidationForField,
  maxLength,
}: FormInputProps) => {
  const formatPhoneNumber = (inputValue: string) => {
    // Use a regular expression to allow only digits and optional hyphens or spaces
    const formattedValue = inputValue.replace(/[^0-9\- ]/g, '');
    return formattedValue;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          {label && (
            <label className='control-label'>
              {label}
              {hint && (
                <DabaduTooltip title={hint} placement='top-end' className='tooltip-wrapper'>
                  <span>
                    <span className='tooltip-wrapper__text'>i</span>
                  </span>
                </DabaduTooltip>
              )}
            </label>
          )}
          <DabaduInput
            type={type}
            InputLabelProps={{ shrink: false }}
            helperText={error ? error.message : null}
            size='small'
            error={!!error}
            onChange={(e) => {
              // clearErrors(name);
              const inputValue = e.target.value;
              const formattedValue = type === 'tel' ? formatPhoneNumber(inputValue) : inputValue;
              onChange(formattedValue);
              triggerValidationForField(name);
            }}
            value={value}
            fullWidth
            placeholder={placeholder}
            variant='outlined'
            inputProps={{ maxLength: maxLength }}
          />
        </>
      )}
    />
  );
};
